<template>
  <div>
    <grid
      v-model:columns="columns"
      v-model:selectedRows="selectedRows"
      v-model="rows"
      :options="options"
      :page="page"
      :per_page="per_page"
      :newRowComponent="newRowComponent"
      :isHideNewRowComponent="isHideNewRowComponent"
      :countRows="countRows"
      :search_text="search_textToGrid"
      @deleteRow="deleteRow"
      @nextPage="nextPage"
      @prevPage="prevPage"
      @saveNewRow="saveNewClientSites"
      @saveRow="saveClientSites"
      @setPerPage="setPerPage"
      @sortRows="fetchData"
      @setTab="setTab"
      @deleteSelected="deleteSelected"
      @exportSelected="exportSelected"
      :listTabs="listTabsProp"
    />
  </div>
  <alert-yes-no
    v-if="isVisibleAfterSaveAlert"
    title="Error"
    :text="textAfterSaveAlert"
    :alertResult="closeAfterSaveAlert"
    :hideYes="false"
    :hideNo="true"
  />
</template>

<script>
import { shallowRef } from 'vue'
import NewRowClientSites from '@/components/NewRows/client/NewRowClientSites'
import { fetchData, fetchCSV, urls } from '@/utils/urls.js'
import { hasAccess, permissions } from '@/utils/permissions'
import { listMixin } from '@/utils/list-mixin'
import { GrigOptions } from '@/models/grid-options'
import { GridColumn } from '@/models/grid-column'

export default {
  name: 'ClientSites',
  mixins: [listMixin],

  emits: ['needToUpdateData', 'setTab'],
  props: {
    listTabsProp: { default: [] },
    client_id: { default: -1 },
    isCanEditGlobal: { default: false },
    isActivatedToEdit: { default: false },
  },

  data() {
    return {
      options: new GrigOptions({
        addButtonText: 'Add site',
        isEditable: this.isEditable,
        isDelete: this.isDelete,
        isAdd: this.isAdd,
        isExportToCSV: hasAccess(permissions.export_client_sites_to_csv),
        getDeleteContent: async (rows) => {
          if (!rows) return ``
          return `<div class="mb-10">
              Are you sure you want to delete site${rows.length > 1 ? 's' : ''}?
              ${rows.map((item) => `<div>• ${item.url}</div>`).join('')}
            </div>`
        },
      }),

      columns: [
        new GridColumn({
          key: 'url',
          text: 'Url',
          formatedValue: ({ value }) => {
            if (value)
              return `<a href="${
                value.includes('http') ? value : '//' + value
              }" title="${value}" target="_blank">${value}</a>`
            return ''
          },
          width: '300px',
          cssClass: 'bold-underline hand',
        }),

        new GridColumn({
          key: 'domain_rating',
          text: 'Domain Rating',
          width: '100px',
        }),

        new GridColumn({
          key: 'organic_traffic',
          text: 'Organic traffic',
          width: '100px',
        }),

        new GridColumn({
          key: 'main_traffic_source',
          text: 'Main traffic source',
          width: '75px',
        }),

        new GridColumn({
          key: 'organic_keywords',
          text: 'Organic keywords',
          width: '100px',
        }),

        new GridColumn({
          key: 'created_by',
          text: 'Created by',
          width: '150px',
        }),

        new GridColumn({
          key: 'modified_by',
          text: 'Last edited by',
          width: '150px',
        }),

        // new GridColumn({
        //   key: 'site_status',
        //   text: 'Site status',
        //   width: '100px',
        // }),

        // new GridColumn({
        //   key: 'niche',
        //   text: 'Niche',
        //   width: '150px',
        // }),

        // new GridColumn({
        //   key: 'sub_niche',
        //   text: 'Sub-niche',
        //   formatedValue: ({ value }) => {
        //     if (!value) return ''

        //     if (value?.length)
        //       return value.map((item) => item?.sub_niche || item).join(', ')

        //     return value
        //   },
        // }),

        // new GridColumn({
        //   key: 'commercial_pages',
        //   text: 'Commercial pages',
        //   width: '100px',
        // }),

        // new GridColumn({
        //   key: 'p2p',
        //   text: 'P2P',
        //   width: '75px',
        // }),

        new GridColumn({
          key: 'sar',
          text: 'SAR',
        }),
      ],

      newClientSites: {
        url: null,
        // niche: null,
        // sub_niche: null,
        //  commercial_pages: null,
        domain_rating: null,
        organic_traffic: null,
        organic_keywords: null,
        //site_status: null,
        //p2p: null,
      },

      newRowComponent: shallowRef(NewRowClientSites),
      initToEdit: -1,
      isVisibleAfterSaveAlert: false,
      textAfterSaveAlert: '',
    }
  },

  watch: {
    isActivatedToEdit() {
      this.options.isEditable = this.isEditable
      this.initToEdit = this.isActivatedToEdit
    },

    isAdd() {
      this.options.isAdd = this.isAdd
    },

    isEditable() {
      this.options.isEditable = this.isEditable
    },

    isDelete() {
      this.options.isDelete = this.isDelete
    },

    rows: {
      handler: function () {
        this.$emit('needToUpdateData', 'statistic')
      },
      deep: true,
    },
  },

  computed: {
    isAdd() {
      return (
        hasAccess(permissions.create_client_site) &&
        this.isActivatedToEdit &&
        this.initToEdit
      )
    },

    isEditable() {
      return this.isCanEditGlobal && this.isActivatedToEdit && this.initToEdit
      //return hasAccess(permissions.update_client_site) && this.isActivatedToEdit && this.initToEdit
    },

    isDelete() {
      return (
        hasAccess(permissions.delete_client_site) &&
        this.isActivatedToEdit &&
        this.initToEdit
      )
    },

    isClientContact() {
      return this.$store.state.currentUser?.client ? true : false
    },
  },

  created() {
    this.initToEdit = this.isActivatedToEdit
    this.hideColumns(['created_by', 'modified_by', 'cost', 'comments'])
    this.fetchData()
  },

  methods: {
    closeAfterSaveAlert() {
      this.isVisibleAfterSaveAlert = false
      this.textAfterSaveAlert = ''
    },

    hideColumns(columnKeys = []) {
      for (const key of columnKeys) {
        let col = this.columns.find((item) => item.key === key)
        if (!col) continue

        col.isHide = this.isClientContact
      }
    },

    setTab(id) {
      this.$emit('setTab', id)
    },

    saveNewClientSites(clientSites) {
      this.setNewClientSites(clientSites)
      this.addRow()
    },

    saveClientSites(clientSites) {
      this.editRow(clientSites)
    },

    newClientSitesToDefault() {
      for (let key in this.newClientSites) {
        this.newClientSites[key] = null
      }
    },

    setNewClientSites(clientSites) {
      for (let key in clientSites) {
        this.newClientSites[key] = clientSites[key]
      }
    },

    async editRow(clientSites) {
      this.$store.commit('setIsLoading', true)
      const id = clientSites.id
      delete clientSites.id

      let body = this.bodyToSave(clientSites)
      body = { ...body, ...{ client_id: this.client_id } }

      let result = await fetchData(urls.clientSites + `/${id}`, 'POST', body)
      if (result?.need_to_popup) {
        this.textAfterSaveAlert = `
          ${result?.message} <a href='/client/${result?.client_id}' target='_blank'>${result?.client_name}</a>
          `

        this.isVisibleAfterSaveAlert = true
      } else if (!result?.detail) {
        let clientSitesRow = this.rows.find((item) => item.id === id)
        for (const key in clientSites) {
          if (key in clientSitesRow) clientSitesRow[key] = clientSites[key]
        }

        this.isHideNewRowComponent = true
        this.$nextTick(() => {
          this.isHideNewRowComponent = false
        })
      } else console.error(result.detail)

      this.$store.commit('setIsLoading', false)
    },

    async addRow() {
      this.$store.commit('setIsLoading', true)

      let body = this.bodyToSave(this.newClientSites)
      body = { ...body, ...{ client_id: this.client_id } }

      let result = await fetchData(urls.clientSites, 'POST', body)

      if (result?.need_to_popup) {
        this.textAfterSaveAlert = `
          ${result?.message} <a href='/client/${result?.client_id}' target='_blank'>${result?.client_name}</a>
          `

        this.isVisibleAfterSaveAlert = true
      } else if (!result?.detail) {
        const tmpClientSites = this.newClientSites
        this.rows.unshift({ ...{ id: result.id }, ...tmpClientSites })
        this.isHideNewRowComponent = true
        this.$nextTick(() => {
          this.isHideNewRowComponent = false
        })

        this.newClientSitesToDefault()
      } else {
        this.isHideNewRowComponent = false
        console.error(result.detail)
      }

      this.$store.commit('setIsLoading', false)
    },

    async deleteRow(ids) {
      let idsLocal = typeof ids === 'object' ? ids : [ids]
      if (!idsLocal || !idsLocal.length) return

      this.$store.commit('setIsLoading', true)

      const deleteEntityQuery = (ids) => {
        let query = ``
        for (const id of ids) {
          query += `sites_ids=${id}&`
        }

        return query
      }

      let query = `client_id=${this.client_id}&`

      if (idsLocal?.length && idsLocal[0] === 'all') {
        query += query = `${
          this.queryToFetch(1, 'all') & deleteEntityQuery(idsLocal)
        }`
      } else {
        query += deleteEntityQuery(idsLocal)
      }

      let result = await fetchData(urls.clientSites, 'DELETE', null, query)
      if (!result?.detail) {
        for (const id of idsLocal) {
          const idx = this.rows.findIndex((item) => item.id === id)
          this.rows.splice(idx, 1)
        }
        this.selectedRows = []
      } else console.error(result.detail)

      this.$store.commit('setIsLoading', false)
    },

    async exportToCSVRows(ids) {
      this.$store.commit('setIsLoading', true)

      const exportQuery = (ids) => {
        let query = `client_id=${this.client_id}&`
        for (const id of ids) {
          query += `sites_ids=${id}&`
        }

        if (query === `client_id=${this.client_id}&`) {
          for (const row of this.rows) {
            query += `sites_ids=${row.id}&`
          }
        }

        return query
      }

      let query = ''

      if (ids?.length && ids[0] === 'all') {
        query += query = `${this.queryToFetch(1, 'all')}&${this.queryToSort()}`
      }

      query += exportQuery(ids)

      await fetchCSV(urls.clientSitesToCsv, 'GET', 'client-sites', null, query)

      this.$store.commit('setIsLoading', false)
    },

    async fetchData() {
      if (this.isLoading && !this.listTabs.length) return

      this.$store.commit('setIsLoading', true)
      let query = `page=${this.page}&per_page=${this.per_page}&client_id=${this.client_id}&`
      let prevSearch_text = this.search_text.value
      if (this.search_text.value?.length > 2) {
        query += `&search_text=${this.search_text.value}`
      }

      query += this.queryToSort()

      let result = await fetchData(urls.clientSites, 'GET', null, query)

      this.rows = result?.rows || []
      this.countRows = result?.count || 0
      this.search_textToGrid = this.search_text.value
      this.$store.commit('setIsLoading', false)

      if (
        this.search_text.value?.length > 2 &&
        prevSearch_text !== this.search_text.value
      )
        this.fetchData()
    },
  },
}
</script>
